module.exports = __webpack_public_path__ + "img/2.07.thmb.xs.8d5880de.jpg";